import React, { Component } from 'react'
import { Table } from 'react-bootstrap'
import _isEqual from 'lodash/isEqual';

class Docentschappen extends Component {
    constructor(props) {
        super(props)
        this.getTeachershipsExaminator = this.getTeachershipsExaminator.bind(this)
        this.getTotalPointsExaminator = this.getTotalPointsExaminator.bind(this)
        this.getTeachershipsAfstudeerbegeleiding = this.getTeachershipsAfstudeerbegeleiding.bind(this)
        this.getTotalPointsAfstudeerbegeleiding = this.getTotalPointsAfstudeerbegeleiding.bind(this)
        this.getTeachershipsGastcollege = this.getTeachershipsGastcollege.bind(this)
        this.getTotalPointsGastcollege = this.getTotalPointsGastcollege.bind(this)
        this.getTeachershipsLesgeven = this.getTeachershipsLesgeven.bind(this)
        this.getTotalPointsLesgeven = this.getTotalPointsLesgeven.bind(this)
        this.state = {
            visibleExaminator: false,
            visibleAfstudeerbegeleiding: false,
            visibleGastcollege: false,
            visibleLesgeven: false
        }
    }
    componentWillReceiveProps(nextProps) {
        if (!_isEqual(nextProps, this.props.data)) {
            let d = this.props.data;
            if (d) {
                let data = this.props.data.filter(t => t.docenType != 'afstudeerbegeleiding' && t.docenType != 'gastcollege' && t.docenType != 'examinator');
                if (data && data.length > 0) this.setState({ visibleLesgeven: true });
                data = this.props.data.filter(t => t.docenType == 'afstudeerbegeleiding');
                if (data && data.length > 0) this.setState({ visibleAfstudeerbegeleiding: true });
                data = this.props.data.filter(t => t.docenType == 'examinator');
                if (data && data.length > 0) this.setState({ visibleExaminator: true });
                data = this.props.data.filter(t => t.docenType == 'gastcollege');
                if (data && data.length > 0) this.setState({ visibleGastcollege: true });
            }
        }
    }
    getTeachershipsLesgeven() {
        let d = this.props.data;
        if (d) {
            let data = this.props.data.filter(t => t.docenType != 'afstudeerbegeleiding' && t.docenType != 'gastcollege' && t.docenType != 'examinator');
            return data && data.length > 0 ? data.map((t, index) => {
                return <tr key={index}>
                    <td>{t.institution}</td>
                    <td>{t.name}</td>
                    <td>{t.level}</td>
                    <td>{t.city}</td>
                    <td>{t.fromYear}</td>
                    <td>{t.finishYear}</td>
                    <td>{t.hours}</td>
                    <td>{t.activities}</td>
                    <td>{t.points}</td>
                </tr>
            }) : null
        }
        else
            return null
    }

    getTotalPointsLesgeven() {
        let d = this.props.data;
        if (d) {
            let data = this.props.data.filter(t => t.docenType != 'afstudeerbegeleiding' && t.docenType != 'gastcollege' && t.docenType != 'examinator');
            return data && data.length > 0 ?
                <tr>
                    <td colSpan='8'><strong>Totaal ke´s</strong></td>
                    <td><strong>{data.map(t => { return t.points }).reduce((acc, val) => acc + val)}</strong></td>
                </tr> : null
        }
        else
            return null
    }

    getTeachershipsAfstudeerbegeleiding() {
        let d = this.props.data;
        if (d) {
            let data = this.props.data.filter(t => t.docenType == 'afstudeerbegeleiding');
            return data && data.length > 0 ? data.map((t, index) => {
                return <tr key={index}>
                    <td>{t.institution}</td>
                    <td>{t.name}</td>
                    <td>{t.level}</td>
                    <td>{t.fromYear}</td>
                    <td>{t.finishYear}</td>
                    <td>{t.typeBij}</td>
                    <td>{t.activities}</td>
                    <td>{t.points}</td>
                </tr>
            }) : null
        }
        else
            return null
    }

    getTotalPointsAfstudeerbegeleiding() {
        let d = this.props.data;
        if (d) {
            let data = this.props.data.filter(t => t.docenType == 'afstudeerbegeleiding');
            return data && data.length > 0 ?
                <tr>
                    <td colSpan='7'><strong>Totaal ke´s</strong></td>
                    <td><strong>{data.map(t => { return t.points }).reduce((acc, val) => acc + val)}</strong></td>
                </tr> : null
        }
        else
            return null
    }
    getTeachershipsExaminator() {
        let d = this.props.data;
        if (d) {
            let data = this.props.data.filter(t => t.docenType == 'examinator');
            return data && data.length > 0 ? data.map((t, index) => {
                return <tr key={index}>
                    <td>{t.institution}</td>
                    <td>{t.name}</td>
                    <td>{t.level}</td>
                    <td>{t.city}</td>
                    <td>{t.fromYear}</td>
                    <td>{t.finishYear}</td>
                    <td>{t.points}</td>
                </tr>
            }) : null
        }
        else
            return null
    }

    getTotalPointsExaminator() {
        let d = this.props.data;
        if (d) {
            let data = this.props.data.filter(t => t.docenType == 'examinator');
            return data && data.length > 0 ?
                <tr>
                    <td colSpan='6'><strong>Totaal ke´s</strong></td>
                    <td><strong>{data.map(t => { return t.points }).reduce((acc, val) => acc + val)}</strong></td>
                </tr> : null
        }
        else
            return null
    }
    getTeachershipsGastcollege() {
        let d = this.props.data;
        if (d) {
            let data = this.props.data.filter(t => t.docenType == 'gastcollege');
            return data && data.length > 0 ? data.map((t, index) => {
                return <tr key={index}>
                    <td>{t.institution}</td>
                    <td>{t.name}</td>
                    <td>{t.level}</td>
                    <td>{t.city}</td>
                    <td>{t.Years}</td>
                    <td>{t.activities}</td>
                    <td>{t.points}</td>
                </tr>
            }) : null
        }
        else
            return null
    }

    getTotalPointsGastcollege() {
        let d = this.props.data;
        if (d) {
            let data = this.props.data.filter(t => t.docenType == 'gastcollege');
            return data && data.length > 0 ?
                <tr>
                    <td colSpan='6'><strong>Totaal ke´s</strong></td>
                    <td><strong>{data.map(t => { return t.points }).reduce((acc, val) => acc + val)}</strong></td>
                </tr> : null
        }
        else
            return null
    }

    render() {
        return (
            <div className="rapport">
                <h5><strong>{this.props.permanent ? "Permanente docentschappen" : "Docentschappen"}</strong></h5>
                <h6 style={{ display: this.state.visibleLesgeven ? 'table' : 'none' }}><strong>{this.props.permanent ? "Permanente lesgeven" : "Lesgeven"}</strong></h6>
                <Table responsive bordered className="lesgeven" style={{ display: this.state.visibleLesgeven ? 'table' : 'none' }}>
                    <thead>
                        <tr>
                            <th>naam instelling</th>
                            <th>naam opleiding</th>
                            <th>niveau</th>
                            <th>plaats</th>
                            <th>van jaar</th>
                            <th>t/m jaar</th>
                            <th>uren/jaar</th>
                            <th>vak</th>
                            <th>Ke's</th>
                        </tr>
                    </thead>
                    <tbody>
                        {this.getTeachershipsLesgeven()}
                        {this.getTotalPointsLesgeven()}
                    </tbody>
                </Table>
                <h6 style={{ display: this.state.visibleAfstudeerbegeleiding ? 'table' : 'none' }}><strong>{this.props.permanent ? "Permanente afstudeerbegeleiding" : "Afstudeerbegeleiding"}</strong></h6>
                <Table responsive bordered className="afstudeerbegeleiding" style={{ display: this.state.visibleAfstudeerbegeleiding ? 'table' : 'none' }}>
                    <thead>
                        <tr>
                            <th>naam instelling</th>
                            <th>naam opleiding</th>
                            <th>niveau</th>
                            <th>van jaar</th>
                            <th>tot jaar</th>
                            <th>naam kandidat</th>
                            <th>naam afstudeeronderwerp</th>
                            <th>Ke's</th>
                        </tr>
                    </thead>
                    <tbody>
                        {this.getTeachershipsAfstudeerbegeleiding()}
                        {this.getTotalPointsAfstudeerbegeleiding()}
                    </tbody>
                </Table>
                <h6 style={{ display: this.state.visibleGastcollege ? 'table' : 'none' }}><strong>{this.props.permanent ? "Permanente gastcollege" : "Gastcollege"}</strong></h6>
                <Table responsive bordered className="gastcollege" style={{ display: this.state.visibleGastcollege ? 'table' : 'none' }}>
                    <thead>
                        <tr>
                            <th>naam instelling</th>
                            <th>naam opleiding</th>
                            <th>niveau</th>
                            <th>plaats</th>
                            <th>datum</th>
                            <th>onderwerp gastcollege</th>
                            <th>Ke's</th>
                        </tr>
                    </thead>
                    <tbody>
                        {this.getTeachershipsGastcollege()}
                        {this.getTotalPointsGastcollege()}
                    </tbody>
                </Table>
                <h6 style={{ display: this.state.visibleExaminator ? 'table' : 'none' }}><strong>{this.props.permanent ? "Permanente examinator" : "Examinator"}</strong></h6>
                <Table responsive bordered className="examinator" style={{ display: this.state.visibleExaminator ? 'table' : 'none' }}>
                    <thead>
                        <tr>
                            <th>naam instelling</th>
                            <th>naam opleiding</th>
                            <th>niveau</th>
                            <th>plaats</th>
                            <th>van jaar</th>
                            <th>tot jaar</th>
                            <th>Ke's</th>
                        </tr>
                    </thead>
                    <tbody>
                        {this.getTeachershipsExaminator()}
                        {this.getTotalPointsExaminator()}
                    </tbody>
                </Table>



            </div>)

    }
}

export default Docentschappen;


// WEBPACK FOOTER //
// ./src/components/Member/Modules/Rapport/Docentschappen.js